import SmoothScroll from 'smoothscroll-for-websites'

export default function ScrollAcceleration () {
  document.addEventListener('DOMContentLoaded', () => {
    const scrollAcceleration = new SmoothScroll({ stepSize: 20 })
    console.log(scrollAcceleration)
  })
}
